module.exports = __webpack_public_path__ + "static/media/praca-ciagla-off.c66994f7.svg";